import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const CompIcon: React.FC<IconProps> = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_295_513)">
        <path
          d="M7 15.4912V16.4982C7.00005 16.8923 6.92244 17.2826 6.77162 17.6467C6.6208 18.0108 6.39971 18.3416 6.121 18.6202L5.5 19.2412H14.5L13.879 18.6202C13.6003 18.3416 13.3792 18.0108 13.2284 17.6467C13.0776 17.2826 13 16.8923 13 16.4982V15.4912M19 3.49121V13.2412C19 13.8379 18.7629 14.4102 18.341 14.8322C17.919 15.2542 17.3467 15.4912 16.75 15.4912H3.25C2.65326 15.4912 2.08097 15.2542 1.65901 14.8322C1.23705 14.4102 1 13.8379 1 13.2412V3.49121M19 3.49121C19 2.89447 18.7629 2.32218 18.341 1.90022C17.919 1.47826 17.3467 1.24121 16.75 1.24121H3.25C2.65326 1.24121 2.08097 1.47826 1.65901 1.90022C1.23705 2.32218 1 2.89447 1 3.49121M19 3.49121V10.2412C19 10.8379 18.7629 11.4102 18.341 11.8322C17.919 12.2542 17.3467 12.4912 16.75 12.4912H3.25C2.65326 12.4912 2.08097 12.2542 1.65901 11.8322C1.23705 11.4102 1 10.8379 1 10.2412V3.49121"
          stroke="currentColor" // Changed to currentColor
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_295_513">
          <rect width="20" height="20" fill="white" transform="translate(0 0.241211)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CompIcon;
